export function StudioEvents(event) {
	if(!event) {
		return;
	}

	const events = blapp.models.get('activities');
	const eventID 		= event.idEvent;
	const eventWinner = event.nWinner;

	if(events) {
		const eventIdx = events.findIndex(item => item.idEvent == eventID);
		let eventContent = {... events[eventIdx]};

		let eventIcons = JSON.parse(eventContent.strIconsConfig);
		eventContent.noIntroTooltip = eventIcons.noIntroTooltip;
		eventContent.intro = eventIcons.intro;
		eventContent.icon = eventIcons.icon;
		eventContent.content = eventIcons.content;

		if(eventWinner) {
			const winnerType 		= eventIcons.winners.findIndex(item => item.position == eventWinner);
			const winnerContent = eventIcons.winners[winnerType];

			eventContent.icon 		= winnerContent.icon;
			eventContent.content 	= winnerContent.content;
			eventContent.type 		= winnerContent.type;
		}

		return eventContent;
	}else{
		return null;
	}
}